module.exports = __webpack_public_path__ + "img/chart-gpt.1b806847.png";